import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAppLoaderContext } from '@/context/AppLoaderContext';
export const useShareComponentEvents = () => {
  const $ = _c(4);
  const router = useRouter();
  const {
    setIsAppLoading
  } = useAppLoaderContext();
  let t0;
  let t1;
  if ($[0] !== router || $[1] !== setIsAppLoading) {
    t0 = () => {
      const handleChangeRoute = function handleChangeRoute(event) {
        const origin = event.detail.origin;
        const path = event.detail.path;
        setIsAppLoading(true);
        if (window.location.origin === origin) {
          router.push(path);
        } else {
          window.location.href = `${origin}${path}`;
        }
        setIsAppLoading(false);
      };
      document.addEventListener("onChangeRoute", handleChangeRoute as EventListener);
      return () => {
        document.removeEventListener("onChangeRoute", handleChangeRoute as EventListener);
      };
    };
    t1 = [router, setIsAppLoading];
    $[0] = router;
    $[1] = setIsAppLoading;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};